<script>
  import { getLoggedIn, getCartCount } from '../../../../../../../js/stores';
  import { filterNavItems } from '../../../../../../../js/navItemFilters';
  import { transitionHeight } from '../../../../../../../js/transitionHeight';

  import CategoryLink from './CategoryLink/CategoryLink.svelte';
  import Spotlight from './Spotlight/Spotlight.svelte';
  import Subcategory from './Subcategory/Subcategory.svelte';

  const TRANSITION_DURATION = '300ms';
  const TRANSITION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();

  export let isOpen = false;
  export let navItems = [];
  export let spotlightConfig = {};

  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });

  $: shouldRenderSpotlight = spotlightConfig && spotlightConfig.items && spotlightConfig.items.length <= 2;
</script>

<ul
  class="CategoryList"
  class:isOpen
  use:transitionHeight={{
    isOpen,
    duration: TRANSITION_DURATION,
    easing: TRANSITION_EASING,
  }}
>
  {#each filteredItems as item (item)}
    {#if item.type === 'category'}
      <li class="category-item" class:hidden={item.hidden}>
        <Subcategory id={item.id} title={item.title} navItems={item.navItems} description={item.description} />
      </li>
    {:else if item.type === 'link'}
      <li class="link-item" class:hidden={item.hidden}>
        <CategoryLink id={item.id} title={item.title} url={item.url} description={item.description} />
      </li>
    {/if}
  {/each}
  {#if shouldRenderSpotlight}
    <Spotlight id={spotlightConfig.id} title={spotlightConfig.title} items={spotlightConfig.items} />
  {/if}
</ul>

<style>.CategoryList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow: hidden;
  position: relative;
  background-size: calc(100% - 50px) 1px;
  background-repeat: no-repeat;
  background-position: top center;
  background-image: linear-gradient(#d9d9d9 0, #d9d9d9 1px, transparent 1px);
  background-image: linear-gradient(var(--color-border, #d9d9d9) 0, var(--color-border, #d9d9d9) 1px, transparent 1px);
}
.CategoryList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.CategoryList > li::before {
  display: none;
}

li:first-child {
  padding-top: 10px;
}
li:last-child {
  padding-bottom: 10px;
}</style>
